<template>
  <div>
    <div class="row gutter-sm" v-for="(address, index) in addresses" :key="index">
      <div :class="[addressesNotEmpty ? 'col-11' : 'col-12']">
        <address-input
          @input="updateAddress($event, index)"
          :value="addresses[index]"
          :id="index"
          :expanded="addressesNotEmpty"
          :label="label"
          :hideLabel="hideLabel"
          :showIcon="showIcon"
          :search-hint="searchHint"
        />
      </div>

      <div v-show="addressesNotEmpty" class="col-1 text-right">
        <q-btn flat dense icon="remove_circle" color="light" class="q-mt-lg" @click="clearAddress(index)"/>
      </div>
    </div>
    <div class="row justify-end">
      <q-btn flat dense
             v-show="addressesNotEmpty"
             @click="addAddress"
             :label="$t('additional_address')"
             :class="showControls ? 'q-mr-xl' : ''"
      />
    </div>
  </div>
</template>

<script>
  import AddressInput from './AddressInput.vue'
  import CustomerAddress from 'src/utils/SubResources/CustomerAddress'
  import { isEqual } from 'lodash'

  export default {
    inject: ['$validator'],

    props: {
      /**
       * Used for v-model
       */
      value: {
        type: Array,
        required: true
      },

      /**
       * Indicate if the label input should be visible
       */
      label: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the label of the email line field should be visible
       */
      hideLabel: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the field icon should be visibile
       */
      showIcon: {
        type: Boolean,
        default: false
      },

      /**
       * Used to suggest addresses before the users start to type
       */
      searchHint: {
        type: String
      }
    },

    data () {
      return {
        addresses: this.value
      }
    },

    computed: {
      showControls () {
        return this.addresses.length > 1
      },

      addressesNotEmpty () {
        return !this.isEmptyAddress(this.addresses[0])
      }
    },

    methods: {
      updateAddress (value, index) {
        this.addresses.splice(index, 1, value)

        this.createDefaultAddress()

        this.emitAddresses()
      },

      addAddress () {
        this.addresses.push(CustomerAddress.empty())
      },

      createDefaultAddress () {
        if (this.addresses.length === 0) {
          this.addAddress()
        }
      },

      clearAddress (index) {
        this.addresses.splice(index, 1)
      },

      isEmptyAddress (address) {
        return isEqual(address, CustomerAddress.empty())
      },

      emitAddresses () {
        this.$emit('input', this.addresses)
      }
    },

    created () {
      this.createDefaultAddress()
    },

    watch: {
      value: {
        handler: function (newAddresses) {
          this.addresses = newAddresses

          this.createDefaultAddress()
        },
        deep: true
      }
    },

    components: {
      AddressInput
    }
  }
</script>
